/* eslint-disable @typescript-eslint/no-explicit-any */
import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'

// 获取产品素材
export const getMaterialList = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/materials/user`, data)
}

// 添加素材图片
export const addMateriaImage = async (data: any): Promise<any> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/pms/materials/user`, data)
}
// 添加素材图片
export const editMateriaImage = async (id: number, data: any): Promise<any> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/pms/materials/user/${id}`, data)
}

// 删除素材图片

export const deleteMateriaImage = async (id: object): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.axios({
    method: 'delete',
    url: '/v1/api/pms/materials/user',
    params: id,
  })
}


